import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router)
  {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : boolean {
    if (this.authService.hasValidJwtShape()) {
      return true;
    }

    // Sesja z przed migracji na JWT (stary "token" = sam login) albo brak
    // tokenu w ogole - czyscimy stan i odsylamy do logowania zamiast
    // wpuszczac na strone, ktora i tak wysypie sie na pierwszym zapytaniu.
    this.authService.logout();
    return false;
  }
}
